import { FONT } from './_constants';

const {
    xsBase,
    smBase,
    mdBase,
    lgBase,
    xlgBase,
    xxlBase,
} = FONT;

export default {
    xsBase,
    smBase,
    mdBase,
    lgBase,
    xlgBase,
    xxlBase,
};



// WEBPACK FOOTER //
// ./src/styles/fontSizes.js